import { combineReducers } from "redux"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"
import cloneDeep from "lodash.clonedeep"

const visits = setterReducer([], t.SET_VISITS)
const name = setterReducer("", t.SET_NAME)
const hasSelf = setterReducer(true, t.SET_HAS_SELF)
const currentVisit = setterReducer(null, t.SET_CURRENT_VISIT)
export const profiles = setterReducer([], t.SET_PROFILES)
const profileDirty = setterReducer(false, t.SET_PROFILE_DIRTY)
const error = setterReducer("", t.SET_PROFILE_ERROR)
const visitError = setterReducer("", t.SET_VISIT_ERROR)
const features = setterReducer({}, t.SET_FEATURES)

const setInnerAnswerState = (question, action) => {
  if (
    question.display_type === "radio" ||
    question.display_type === "dropdown"
  ) {
    if (
      question.answer &&
      question.options[question.answer[0]].extensions.length > 0
    ) {
      question.options[question.answer].extensions.forEach(
        e => (e.answer = null)
      )
    }
    if (question.answer && question.answer.includes(action.token) && question.display_type === "radio") {
      question.answer = null
    } else {
      question.answer = [action.token]
    }
  } else if (question.answer && question.answer.length > 0) {
    const inAnswer = question.answer.find(a => a === action.token)
    if (inAnswer) {
      question.answer = question.answer.filter(a => a !== action.token)
    } else {
      question.answer.push(action.token)
    }
  } else {
    question.answer = [action.token]
  }
}

const setInnerAnswerAndExtension = (question, action) => {
  question.answer = [action.option]
  question.options[action.option].extensions[action.extension].answer = [action.token]
}

const predispositions = (state = {}, action) => {
  switch (action.type) {
    case t.SET_PREDISPOSITIONS:
      return { ...action.payload, snapshots: {} }
    case t.SET_PREDISPOSITION_ANSWER: {
      const newState = { ...state }
      if (action.option) {
        if ( newState[action.category].questions[action.question].answer &&
          newState[action.category].questions[action.question].answer.length > 0 &&
          newState[action.category].questions[action.question].answer.includes(action.option) ) {
          setInnerAnswerState(
            newState[action.category].questions[action.question].options[action.option].extensions[action.extension],
            action
          )
        } else {
          setInnerAnswerAndExtension(
            newState[action.category].questions[action.question],
            action
          )
        }
      } else {
        setInnerAnswerState(
          newState[action.category].questions[action.question],
          action
        )
      }
      return { ...newState }
    }
    case t.CANCEL_EDIT_PREDISPOSITIONS: {
      return {
        ...state,
        [action.category]: state.snapshots[action.category]
      }
    }
    case t.EDIT_PREDISPOSITIONS: {
      return {
        ...state,
        snapshots: {
          ...state.snapshots,
          [action.category]: cloneDeep(state[action.category]),
        },
      }
    }
    default:
      return state
  }
}

const account = combineReducers({
  profiles,
  visits,
  name,
  hasSelf,
  currentVisit,
  profileDirty,
  error,
  visitError,
  features,
  predispositions,
})

export { account as default }



// WEBPACK FOOTER //
// ./assets/account/reducer.js